<template>
  <UiModal
    :show="showRule"
    title="竞猜规则"
    iconType="quiz_1"
    @close="close"
  >
    <div class="rule-box">
      <div class="inner">
        <div class="rule" v-for="(item, key) in ruleList" :key="key">
          <div class="title">{{ item.title }}</div>
          <div class="des" v-if="item.des">{{ item.des }}</div>
          <ul v-if="item.rule">
            <li v-for="(rule, i) in item.rule" :key="i">
              <span>{{ rule }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </UiModal>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useModal } from '@/composables/useModal'
import * as api from "@/service/index";
import UiModal from "@/components/ui-modal.vue";

const showRule = ref(false);
const ruleList = ref([]);
const { close } = useModal('quiz-rule', showRule)

onMounted(() => {
  getRule();
});

async function getRule() {
  let response = await api.reqRule();
  if (response.status === 200) {
    ruleList.value = response.data;
  }
}
</script>

<style lang="scss" scoped>
.rule-box {
    height: 100%;
    font-size: 20px;
    padding: 32px 32px 50px 58px;
    box-sizing: border-box;

    .inner {
        height: 100%;
        padding-right: 26px;
        padding-left: 0;
        overflow-x: hidden;
        overflow-y: scroll;

        .rule {
            margin-bottom: 30px;
            color: #666;

            .title {
                font-size: 24px;
                color: #333;
                margin-bottom: 10px;
            }

            ul {
                font-size: 20px;
                li {
                    display: flex;
                    justify-content: flex-start;
                    margin-bottom: 5px;

                    &::before {
                        content: '';
                        flex-shrink: 0;
                        width: 27px;
                        height: 27px;
                        margin: 2px 5px 0 0;
                        @include icon_status('rule_bullet');
                    }
                }
            }
        }
    }

    ::-webkit-scrollbar {
        display: block !important;
    }
}
</style>
